import { Imagen } from "./imagen";

export class Parte {
  public partId: number;
    public codigo: string;
    public nombre: string;
    public descripcion: string;
    public especificaciones: string;
    public usabilidad: string;
    public aplicabilidad: string;
    public sustitutas: string;
    public clasId: number;
    public clasificacion: string;
    public marca: string;
    public unidadesVehiculo: number;
    public unidadManejo: number;
    public peso: number;
    public kilometrajeCambio: number;
    public alto: number;
    public ancho: number;
    public largo: number;
    public publicado: string;
    public imagenes: Array<Imagen>;
    public precioVenta: number;
    public stock: number;
    public fechaDisponible: Date;
    public totalVendido : number;
    public porcentaje : number;
    public totalBruto : number;
    public iva : number;
    public nombreCiudad: string;
    public nombreProvincia: string;

  constructor() { }
}